import datasetEmpty from "@/assets/dataset_empty.svg";
import { PlusIcon } from "@/icons";
import { Link } from "@/kit/ui/link";
import { FormattedMessage } from "react-intl";

export function DatasetsEmpty() {
  return (
    <div className="flex flex-col items-center gap-6">
      <img src={datasetEmpty} />
      <div className="flex flex-col items-center gap-1 w-80">
        <p className="text-grey-900 text-lg font-semibold">
          <FormattedMessage defaultMessage="No datasets yet" />
        </p>
        <p className="text-grey-600 text-sm font-normal text-center">
          <FormattedMessage defaultMessage="Once you create a dataset, it will appear here. Get started by creating your first one." />
        </p>
      </div>

      <Link variant="primary" to="/datasets/new">
        <PlusIcon className="w-5 h-5" />
        <FormattedMessage defaultMessage="Create dataset" />
      </Link>
    </div>
  );
}
